module.exports = __webpack_public_path__ + "images/Group 12589284dcc8a9fa1c772e9d140d5e04a25f.svg";